<template>
    <div class="flex flex-col flex-1">
        <question-header :question="question" :instructions="instructions" :required="required" class="mb-6 md:mb-10"/>
        <div class="flex flex-col flex-1">
            <div class="flex flex-col flex-1 justify-center">
                <label
                       class="block text-muted-500 font-bold text-base md:text-lg mb-3 md:mb-6">
                    <input class="block w-full border bg-light-200 border-light-200 rounded-full py-1 sm:py-2 md:py-4 px-3 md:px-6 focus:outline-none text-muted-500 font-bold focus:bg-transparent focus:border-lightGrey-200 mb-4 mt-3"
                       type="text"
                       v-model="value">
                </label></div>

            <div v-if="errorMessage" class="w-full py-1 sm:py-2 md:py-3 pl-6 mt-8 md:mt-12 bg-risk-400 rounded-full text-center text-base md:text-2xl text-light-100">
                {{ errorMessage }}
            </div>
        </div>
    </div>
</template>

<script>
    import QuestionHeader from './QuestionHeader';
    import * as EmailValidator from 'email-validator/index';

    export default {
        components: {
            QuestionHeader
        },

        props: {
            question: {
                type: Object,
                required: true
            },
            required: {
                type: Boolean,
                required: true
            },
            instructions: Object,
            answer: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                value: '',
                errorMessage: null
            }
        },
        watch: {
            value(data) {
                this.$emit('input', [{
                    index: 0,
                    value: data
                }]);
            }
        },
        methods: {
            validate() {
                if (!this.required) {
                    return true;
                }

                const valid = !!this.value.length && EmailValidator.validate(this.value);

                this.errorMessage = !valid ? "This field must be a valid email address!" : null;
                return valid;
            }
        },
        mounted() {
            if (this.answer[0]) {
                this.value = this.answer[0].value;
            }
        }
    }
</script>
